export default "__VITE_ASSET__2OZxxpWZ__"